import { myStyleDark, myStyleLight } from "../dist/helpers";

const entries = [
  {
    version: "1.0",
    title: "Website Live",
    date: "Oct 14, 2024",
    badge: "Launch",
    badgeColor: "#4ade80",
    description:
      "Dilks Software Solutions goes live. The site publishes to the public for the first time — a clean foundation for showcasing consulting services.",
  },
  {
    version: "2.0",
    title: "Expanded Navigation",
    date: "Aug 30, 2025",
    badge: "Feature",
    badgeColor: "#3b82f6",
    description:
      "Expanding the platform to make it easier for potential clients to connect. Introducing fully functional About Us and Contact Us sections — previously teased as coming soon.",
  },
  {
    version: "2.1",
    title: "Visual Redesign",
    date: "Feb 7, 2026",
    badge: "Improvement",
    badgeColor: "#8b5cf6",
    description:
      "Auto-renewing SSL certificates keep the site secure with zero maintenance overhead. Major design overhaul — modern layout system, polished typography, dark mode, photo sections, and improved mobile experience across all pages.",
  },
  {
    version: "2.2",
    title: "AI Enabled",
    date: "Feb 20, 2026",
    badge: "Improvement",
    badgeColor: "#8b5cf6",
    isNew: true,
    description:
      "By leveraging cutting edge AI tools like Claud, Cursor, and Grok, we’ve streamlined content creation and site maintenance. AI-assisted copywriting, image generation, and code management allow us to focus on delivering value to clients while keeping the site fresh and engaging with minimal overhead. Using the latest technotogies allows us to better understand what tools we can apply to your business.",
  },
].reverse();

export default function Changelog({ finalIsDarkMode }) {
  const tc      = finalIsDarkMode ? "text-white" : "text-black";
  const mc      = finalIsDarkMode ? "text-white-50" : "text-muted";
  const surface = finalIsDarkMode ? myStyleDark : myStyleLight;
  const pageBg  = finalIsDarkMode
    ? { background: "#0d1526", minHeight: "100vh" }
    : { background: "#f1f5f9", minHeight: "100vh" };

  return (
    <div style={pageBg}>

      {/* ─── PAGE HERO ─────────────────────────────────────── */}
      <div
        className="page-hero"
        style={{ background: "linear-gradient(135deg, #1e3a8a 0%, #4f46e5 55%, #7c3aed 100%)" }}
      >
        <div style={{
          position: "absolute", top: "-30%", right: "-5%",
          width: 440, height: 440, borderRadius: "50%",
          background: "rgba(255,255,255,0.04)", pointerEvents: "none",
        }} />
        <div style={{
          position: "absolute", bottom: "-40%", left: "-5%",
          width: 320, height: 320, borderRadius: "50%",
          background: "rgba(255,255,255,0.03)", pointerEvents: "none",
        }} />
        <div className="container" style={{ position: "relative", zIndex: 1 }}>
          <span className="section-label" style={{ color: "#c4b5fd" }}>Updates</span>
          <h1 className="display-5 fw-bold text-white mb-3">Changelog</h1>
          <p className="text-white-50 mb-0" style={{ fontSize: "1.1rem", maxWidth: 500, lineHeight: 1.7 }}>
            A complete history of improvements, feature additions, and milestones.
          </p>
        </div>
      </div>

      {/* ─── ENTRIES ───────────────────────────────────────── */}
      <div className="container py-5">
        <div className="row g-4">
          {entries.map((entry) => (
            <div key={entry.version} className="col-md-6">
              <div className="h-100 p-4 rounded-3 card-hover" style={surface}>

                {/* Badge row */}
                <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">
                  <span className="tech-badge" style={{
                    background: `${entry.badgeColor}18`,
                    color: entry.badgeColor,
                    border: `1px solid ${entry.badgeColor}38`,
                    fontSize: 12,
                    padding: "4px 14px",
                    borderRadius: 100,
                  }}>
                    {entry.badge}
                  </span>
                  {entry.isNew && (
                    <span className="badge rounded-pill" style={{
                      background: "rgba(34,211,238,0.14)",
                      color: "#22d3ee",
                      fontSize: 11,
                      fontWeight: 600,
                    }}>
                      NEW
                    </span>
                  )}
                </div>

                {/* Version */}
                <div className="fw-bold mb-1" style={{
                  fontSize: "0.82rem",
                  background: "linear-gradient(135deg, #3b82f6, #22d3ee)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  letterSpacing: "0.5px",
                }}>
                  VERSION {entry.version}
                </div>

                <h3 className={`fw-bold mb-1 ${tc}`}>{entry.title}</h3>
                <div className={`mb-3 ${mc}`} style={{ fontSize: 13 }}>{entry.date}</div>
                <p className={`mb-0 ${mc}`} style={{ lineHeight: 1.75, fontSize: 20 }}>{entry.description}</p>

              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}
